import { __assign, __extends } from "tslib";
import * as React from 'react';
import { View, Image, I18nManager, StyleSheet, Platform } from 'react-native';
import AppbarAction from './AppbarAction';
//import MaterialCommunityIcon from '../MaterialCommunityIcon';
/**
 * A component used to display a back button in the appbar.
 */
var AppbarBackAction = /** @class */function (_super) {
  __extends(AppbarBackAction, _super);
  function AppbarBackAction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AppbarBackAction.prototype.render = function () {
    var _this = this;
    return /*#__PURE__*/React.createElement(AppbarAction, __assign({}, this.props, {
      icon: function (_a) {
        var size = _a.size,
          color = _a.color;
        return Platform.OS === 'ios' || Platform.OS === 'android' ? (/*#__PURE__*/React.createElement(View, {
          style: [styles.wrapper, {
            width: size,
            height: size,
            transform: [{
              scaleX: I18nManager.isRTL ? -1 : 1
            }]
          }]
        }, /*#__PURE__*/React.createElement(Image, {
          source: _this.props.backbutton,
          style: [styles.icon, {
            tintColor: color
          }]
        }))) : null // <MaterialCommunityIcon
        //   name="arrow-left"
        //   color={color}
        //   size={size}
        //   direction={I18nManager.isRTL ? 'rtl' : 'ltr'}
        // />
        ;
      }
    }));
  };
  AppbarBackAction.displayName = 'Appbar.BackAction';
  AppbarBackAction.defaultProps = {
    accessibilityLabel: 'Back'
  };
  return AppbarBackAction;
}(React.Component);
var styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  icon: {
    height: 21,
    width: 21,
    resizeMode: 'contain'
  }
});
export default AppbarBackAction;